import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'be',
    fullName: 'Belarusian',
    nativeName: 'Беларуская',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Набліжаецца нешта дзіўнае",
    landing_subtitle: "ArgVoid - студыя распрацоўкі праграм і гульняў. Сачыце за навінамі, хутка з'явяцца новыя рэчы!",
    select_language: "Выберыце мову",
    search_placeholder: "Шукаць мовы...",
    terms_title: "Умовы абслугоўвання",
    policy_title: "Палітыка прыватнасці",
    cookies_title: "Палітыка выкарыстання файлаў cookie",
    terms_content: `
        <strong>1. Прыняцце Умоў </strong><br>
        Атрымліваючы доступ да ArgVoid, гэтыя Умовы абслугоўвання прымаюцца. Калі гэтыя ўмовы не згодныя, паслуга не павінна выкарыстоўвацца.<br><br>

        <strong>2. Выкарыстанне платформы </strong><br>
        ArgVoid і яго прыкладанні прадастаўляюцца "як ёсць" у інфармацыйных і творчых мэтах. Сэрвіс павінен выкарыстоўвацца толькі ў законных мэтах.<br><br>

        <strong>3. Забароненыя паводзіны </strong><br>
        Выкарыстанне ўразлівасцяў сайта, спам або спроба несанкцыянаванага доступу да інфраструктуры строга забароненыя.<br><br>

        <strong>4. Адмова ад адказнасці </strong><br>
        Платформа і паслугі могуць быць зменены ў любы час без папярэдняга паведамлення. Не прадастаўляецца гарантыя адносна часу бесперабойнай працы або даступнасці паслугі.
    `,
    policy_content: `
        <strong>1. Зборнік інфармацыі </strong><br>
        На дадзены момант платформа не патрабуе аўтэнтыфікацыі карыстальніка або стварэння ўліковага запісу. Асабістыя ідэнтыфікацыйныя звесткі (напрыклад, імёны або адрасы электроннай пошты) актыўна не збіраюцца ў наведвальнікаў.<br><br>

        <strong>2. Дадзеныя аб выкарыстанні </strong><br>
        Базавая ананімная аналітыка можа збірацца для разумення наведвальнасці сайта і паляпшэння прыкладанняў. Гэтыя даныя не звязаны з асобнымі асобамі карыстальнікаў.<br><br>

        <strong>3. Паслугі трэціх асоб </strong><br>
        Для паслуг хостынгу і аналітыкі могуць выкарыстоўвацца староннія пастаўшчыкі. Практыка прыватнасці гэтых адпаведных пастаўшчыкоў рэгулюе ананімныя дадзеныя, якія апрацоўваюцца ў іх інфраструктуры. <br><br>

        <strong>4. Бяспека дадзеных </strong><br>
        Для абароны платформы прымяняюцца разумныя меры бяспекі. Аднак ні адзін спосаб перадачы праз Інтэрнэт не з'яўляецца цалкам бяспечным.<br><br>
    `,
    cookies_content: `
        <strong>1. Што такое файлы cookie і лакальнае сховішча? </strong><br>
        Файлы cookie і лакальнае сховішча браўзера - гэта невялікія файлы дадзеных, якія захоўваюцца на прыладзе для запамінання налад канфігурацыі падчас наведванняў.<br><br>

        <strong>2. Мэта выкарыстання </strong><br>
        LocalStorage браўзера выкарыстоўваецца выключна для захавання параметраў канфігурацыі, напрыклад: <br>
        - Моўныя перавагі <br>
        - Канфігурацыя карыстальніцкага інтэрфейсу (напрыклад, налады макета або тэмы) <br>
        - Кэш часовага прыкладання <br><br>

        <strong>3. Няма адсочвання </strong><br>
        Файлы cookie і лакальнае сховішча не выкарыстоўваюцца ў мэтах рэкламы або адсочвання трэцімі асобамі. Усе захаваныя даныя прызначаны выключна для асноўных функцый платформы. <br><br>

        <strong>4. Control</strong><br>
        Даныя браўзера можна ачысціць у любы час праз налады браўзера, што прывядзе да скіду любых лакальных канфігурацый.
    `,
    cookie_consent_text: "Мы выкарыстоўваем асноўныя файлы cookie, каб гарантаваць карэктную працу вэб-сайта, напрыклад, падтрымліваць ваш сеанс актыўным, захоўваць вашы моўныя перавагі і іншыя карыстальніцкія канфігурацыі.",
    read_policy: "Прачытайце палітыку выкарыстання файлаў cookie",
    support_title: "Звярніцеся ў службу падтрымкі",
    support_subject_label: "Прадмет",
    support_message_label: "паведамленне",
    support_submit_button: "Адправіць паведамленне",
    support_hint: "Заўвага: гэта адкрые стандартную праграму электроннай пошты для адпраўкі паведамлення.",
    support_success_msg: "Адкрыццё праграмы электроннай пошты...",
    support_error_msg: "Не ўдалося адправіць паведамленне. Паўтарыце спробу пазней.",
    explorer_title: "Правадыр",
    history_title: "Гісторыя",
    animation_title: "Анімацыя",
    config_title: "Канфігурацыя",
    tool_mouse: "Выбраць (Ctrl+M)",
    tool_brush: "Пэндзаль (Ctrl+B)",
    tool_brush_mode: "Рэжым пераключэння (суцэльны/чысты)",
    tool_eraser: "Гумка (Ctrl+E)",
    tool_brush_size: "Адрэгулюйце памер пэндзля",
    tool_bucket: "Запоўніць (Ctrl+F)",
    tool_eyedropper: "Вочная піпетка",
    tool_grid: "Сетка (Ctrl+Shift+B)",
    tool_rotate: "Павярнуць (Ctrl+Shift+R)",
    tool_flip_h: "Перавярнуць H (Ctrl+Shift+H)",
    tool_flip_v: "Перавярнуць V (Ctrl+Shift+V)",
    tool_transpose: "Транспанаваць (Ctrl+Shift+T)",
    label_width: "Шырыня",
    label_height: "Вышыня",
    label_frames: "Колькасць кадраў",
    label_animation: "Стыль анімацыі",
    label_background_color: "Колер фону",
    label_interval: "Інтэрвал",
    tool_anim_config: "Канфігурацыя анімацыі",
    label_new_width: "Новая шырыня",
    label_new_height: "Новая вышыня",
    label_apply: "Ужыць",
    label_colors: "Колеры",
    label_size: "Памер",
    label_tolerance: "Талерантнасць",
    val_horizontal: "Гарызантальны",
    val_vertical: "Вертыкальны",
    val_sequence: "Паслядоўнасць",
    val_bounce: "Падскокваць",
    val_random: "Выпадковы",
    val_solid: "Цвёрды",
    val_clear: "Ясна",
    action_add_sheet: "Новы аркуш",
    action_import: "Імпарт",
    action_export: "Экспарт",
    action_sort_projects: "Сартаваць",
    sort_date_old: "Спачатку самыя старыя",
    sort_date_new: "Спачатку найноўшыя",
    sort_name_az: "Імя (А-Я)",
    sort_name_za: "Імя (Я-А)",
    action_new_sprite: "Новы спрайт",
    action_new_project: "Новы праект",
    modal_save_all_title: "Захаваць усе змены",
    modal_save_all_desc: "Выберыце актывы для захавання:",
    modal_save_selected: "Захаваць выбранае",
    action_saved: "Захавана",
    modal_create_sprite_title: "Стварыць новы спрайт",
    modal_create_project_title: "Стварыць новы праект",
    modal_add_sheet_title: "Дадаць новы ліст",
    modal_rename_sheet_title: "Перайменаваць ліст",
    modal_rename_sprite_title: "Перайменаваць Sprite",
    modal_delete_sprite_title: "Выдаліць спрайт",
    modal_delete_project_title: "Выдаліць праект",
    modal_delete_sheet_title: "Выдаліць ліст",
    placeholder_sprite_name: "Імя",
    placeholder_project_name: "Імя",
    placeholder_sheet_name: "Імя",
    placeholder_new_name: "Новая назва",
    action_create: "Ствараць",
    action_add: "Дадаць",
    action_rename: "Перайменаваць",
    action_duplicate: "Дублікат",
    action_delete: "Выдаліць",
    action_cancel: "Адмяніць",
    confirm_delete_sprite: "Вы ўпэўнены, што хочаце выдаліць гэты спрайт?",
    confirm_delete_project: "Вы ўпэўнены, што хочаце выдаліць гэты праект? Усе спрайты будуць выдалены.",
    confirm_delete_sheet: "Вы ўпэўнены, што хочаце выдаліць гэты аркуш?",
    err_select_sprite: "Спачатку абярыце спрайт.",
    err_select_project: "Спачатку абярыце праект.",
    err_name_empty: "Імя не можа быць пустым.",
    err_sprite_exists: "Спрайт з такой назвай ужо існуе.",
    err_project_exists: "Праект з такой назвай ужо існуе.",
    err_no_content: "Няма змесціва для захавання.",
    err_no_changes: "Няма змяненняў для захавання.",
    err_delete_last_sheet: "Немагчыма выдаліць апошні аркуш.",
    err_extract_frames: "Не ўдалося атрымаць кадры.",
    err_indexeddb: "Не ўдалося захаваць лакальна. Магчыма, ваш браўзер не падтрымлівае IndexedDB.",
    msg_upload_success: "Паспяховая загрузка: {0}",
    msg_upload_failed: "Памылка загрузкі: {0}",
    msg_save_success: "Захаванне паспяховае.",
    msg_saving: "Захаванне...",
    msg_multi_save_result: "Захавана {0} актываў. Памылак: {1}.",
    menu_title: "Меню",
    menu_save: "Захаваць",
    menu_save_all: "Захаваць усе",
    menu_support: "Звярніцеся ў службу падтрымкі",
    label_local_storage: "Лакальнае сховішча",
    label_sign_in: "Увайдзіце",
    modal_export_title: "Экспарт Sprite",
    label_filename: "Імя файла",
    label_format: "фармат",
    action_export_confirm: "Экспарт",
};

export default translations;
